module.exports = __webpack_public_path__ + "static/img/reg-lf.4681438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/reg-lf.png
// module id = 12ov
// module chunks = 1